import { isNil, get } from 'lodash';
import AuthService from '@/services/AuthService';

const authService = new AuthService();

// eslint-disable-next-line consistent-return
function validateUser(userInfo) {
  const { profile } = userInfo;

  const userId = get(profile, 'x-hasura-user-id');
  if (isNil(userId)) {
    setTimeout(() => {
      location.href = 'https://cat4mro.com';
    }, 1000);
  } else {
    return true;
  }
}

export default function auth({ to, next }) {
  authService.getUser().then((userInfo) => {
    if (userInfo && !userInfo.expired && validateUser(userInfo)) {
      next();
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/router/middlewares/auth.js